(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  function setCheckoutLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function relocateBloyCartRewards() {
    const root = document.getElementById('main-cart-footer');
    if (!root) return;

    const rewardsList = root.querySelectorAll('.BLOY-cart__rewards');
    const blocks = root.querySelector('.cart__blocks');
    if (!rewardsList.length || !blocks) return;

    rewardsList.forEach((rewards) => {
      if (rewards.nextElementSibling === blocks) return;
      blocks.parentNode.insertBefore(rewards, blocks);
    });
  }

  function observeBloyCartRewards() {
    const root = document.getElementById('main-cart-footer');
    if (!root || root.dataset.bloyObserved === 'true') return;

    root.dataset.bloyObserved = 'true';
    relocateBloyCartRewards();
    new MutationObserver(relocateBloyCartRewards).observe(root, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('#checkout.cart__checkout-button');
    if (!checkoutButton || checkoutButton.disabled) return;
    setCheckoutLoading(checkoutButton, true);
  });

  window.addEventListener('pageshow', () => {
    setCheckoutLoading(document.querySelector('#checkout.cart__checkout-button'), false);
  });

  function refreshCartFooterTotals() {
    const mainCartFooter = document.getElementById('main-cart-footer');
    const sectionId = mainCartFooter?.dataset.id;
    if (!mainCartFooter || !sectionId) return Promise.resolve();

    const cartUrl = window.routes?.cart_url || '/cart';
    return fetch(`${cartUrl}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const target = mainCartFooter.querySelector('.js-contents');
        const source = html.querySelector('#main-cart-footer .js-contents') || html.querySelector('.js-contents');
        if (target && source) target.innerHTML = source.innerHTML;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function scheduleCartFooterRefresh(delay) {
    window.clearTimeout(window.__cartFooterRefreshTimer);
    window.__cartFooterRefreshTimer = window.setTimeout(() => {
      refreshCartFooterTotals();
    }, delay || 350);
  }

  function isCartOrDiscountRequest(url, body) {
    const href = String(url || '');
    if (!href || href.includes('section_id=')) return false;
    if (/\/cart\/(add|update|change|clear)(\.js)?(\?|$)/i.test(href)) return true;
    if (/\/discount(\/|\.js|\?|$)/i.test(href)) return true;
    if (/coupon|promo[-_]?code|discount[-_]?code|apply[-_]?discount/i.test(href)) return true;

    const payload = typeof body === 'string' ? body : '';
    return /["']?discount["']?\s*[:=]/i.test(payload);
  }

  function hookCartDiscountRefresh() {
    if (window.__cartFooterDiscountHooked) return;
    window.__cartFooterDiscountHooked = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : input?.url;
        const body = init?.body ?? (typeof input === 'object' ? input.body : '');
        const request = originalFetch.apply(this, arguments);
        if (isCartOrDiscountRequest(url, body)) {
          request.finally(() => scheduleCartFooterRefresh());
        }
        return request;
      };
    }

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartFooterUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (isCartOrDiscountRequest(this.__cartFooterUrl, body)) {
        this.addEventListener('loadend', () => scheduleCartFooterRefresh());
      }
      return originalSend.apply(this, arguments);
    };

    ['cart:updated', 'cart:change', 'discount:applied', 'theme:cart:change'].forEach((eventName) => {
      document.addEventListener(eventName, () => scheduleCartFooterRefresh());
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.coupon__wrapper button, .coupon__wrapper [type="submit"]')) {
        scheduleCartFooterRefresh(600);
      }
    });

    const couponWrapper = document.querySelector('#main-cart-footer .coupon__wrapper');
    if (couponWrapper) {
      let ready = false;
      window.setTimeout(() => {
        ready = true;
      }, 800);
      new MutationObserver(() => {
        if (!ready) return;
        scheduleCartFooterRefresh();
      }).observe(couponWrapper, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeBloyCartRewards();
      hookCartDiscountRefresh();
    });
  } else {
    observeBloyCartRewards();
    hookCartDiscountRefresh();
  }

  } catch(e) { console.error(e); }
})();
})();
